<div class="zwi-display">
  <ng-content></ng-content>
</div>
